import React from "react";
import {BasePage, Spinner} from "peggirkit";
import router from "@/routing/Router";
import {useIntl} from "react-intl";

const HydrationFallback = () => {
    const intl = useIntl();
    const route = router.appLoader;

    return (
        <BasePage
            appName={intl.formatMessage({id: "appName"})}
            title={route.name(intl)}
        >
            <div className={"w-full h-full flex items-center justify-center p-6"}>
                <Spinner size={"lg"}/>
            </div>
        </BasePage>
    );
};

export default HydrationFallback;